<template>
  <Chart :option="option"></Chart>
</template>

<script>
import Chart from './chart';
import * as echarts from 'echarts';
export default {
  components: {
    Chart
  },
  props: {
    types: {
      type: Array,
      default: () => []
    },
    endTime: String,
    startTime: String
  },
  data() {
    return {
      option: {}
    };
  },
  watch: {
    types: {
      deep: true,
      handler() {
        this.option = this.getOptions();
      }
    }
  },
  created() {
    this.option = this.getOptions();
  },
  methods: {
    getOptions() {
      const option = {
        textStyle: {
          color: '#fff'
        },
        grid: {
          show: true,
          backgroundColor: '#fff',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          width: 'auto' //图例宽度
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: false,
          max: this.endTime || 'dataMax',
          min: this.startTime || 'dataMin',
          position: 'top'
        },
        yAxis: {
          axisTick: {
            length: 1
          },
          min: 0,
          data: this.types.map(i => {
            return {
              value: i._name
            };
          })
        },
        series: [
          {
            type: 'custom',
            renderItem: (params, api) => {
              var categoryIndex = api.value(0);
              var start = api.coord([api.value(1), categoryIndex]);
              var end = api.coord([api.value(2), categoryIndex]);
              var height = api.size([0, 1])[1];

              var rectShape = echarts.graphic.clipRectByRect(
                {
                  x: start[0],
                  y: start[1] - height / 2,
                  width: end[0] - start[0],
                  height: height
                },
                {
                  x: params.coordSys.x,
                  y: params.coordSys.y,
                  width: params.coordSys.width,
                  height: params.coordSys.height
                }
              );

              return (
                rectShape && {
                  type: 'rect',
                  shape: rectShape,
                  style: api.style()
                }
              );
            },
            encode: {
              x: [1, 2]
            },
            data: this.types.reduce((acc, c) => {
              acc = [...acc, ...c.value];
              return acc;
            }, [])
          }
        ]
      };

      return option;
    }
  }
};
</script>

<style></style>
